import { render, staticRenderFns } from "./ItemVedett6m.vue?vue&type=template&id=5871cd2e&scoped=true&"
import script from "./ItemVedett6m.vue?vue&type=script&lang=js&"
export * from "./ItemVedett6m.vue?vue&type=script&lang=js&"
import style0 from "./ItemVedett6m.vue?vue&type=style&index=0&id=5871cd2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871cd2e",
  null
  
)

export default component.exports